import { render, staticRenderFns } from "./RestorePassword.vue?vue&type=template&id=3ea51630&scoped=true&"
import script from "./RestorePassword.vue?vue&type=script&lang=js&"
export * from "./RestorePassword.vue?vue&type=script&lang=js&"
import style0 from "./RestorePassword.vue?vue&type=style&index=0&id=3ea51630&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea51630",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ea51630')) {
      api.createRecord('3ea51630', component.options)
    } else {
      api.reload('3ea51630', component.options)
    }
    module.hot.accept("./RestorePassword.vue?vue&type=template&id=3ea51630&scoped=true&", function () {
      api.rerender('3ea51630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/views/public/login/RestorePassword.vue"
export default component.exports